if (!customElements.get('vb2-motion-hero')) {
  class VB2MotionHero extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.videoSlot = this.querySelector('[data-vb2-video-slot]');
      this.control = this.querySelector('[data-vb2-video-control]');
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.manuallyStarted = false;
      const options = { signal: this.controller.signal };

      this.control.addEventListener('click', () => {
        if (this.video && !this.video.paused) {
          this.userPaused = true;
          this.video.pause();
        } else {
          this.userPaused = false;
          this.manuallyStarted = true;
          this.play();
        }
      }, options);

      this.desktop.addEventListener('change', () => this.selectCrop(), options);
      this.reducedMotion.addEventListener('change', () => {
        this.manuallyStarted = false;
        if (this.reducedMotion.matches) {
          this.video?.pause();
          this.videoSlot.classList.remove('has-played');
        } else if (this.shouldPlay()) {
          this.play();
        }
      }, options);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video?.pause();
        else if (this.shouldPlay()) this.play();
      }, options);

      this.selectCrop();
    }

    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.controller = null;
    }

    shouldPlay() {
      return !this.userPaused && !document.hidden && (!this.reducedMotion.matches || this.manuallyStarted);
    }

    selectCrop() {
      this.video?.pause();
      this.video = null;
      this.videoSlot.replaceChildren();
      this.videoSlot.classList.remove('has-played');
      const crop = this.desktop.matches ? 'desktop' : 'mobile';
      this.videoTemplate = this.querySelector(`[data-vb2-video="${crop}"]`) || this.querySelector('[data-vb2-video]');
      this.control.hidden = !this.videoTemplate;
      this.updateControl();
      if (this.videoTemplate && this.shouldPlay()) this.play();
    }

    createVideo() {
      if (this.video || !this.videoTemplate) return;
      this.videoSlot.append(this.videoTemplate.content.cloneNode(true));
      this.video = this.videoSlot.querySelector('video');
      const video = this.video;
      if (!video) return;
      video.id = `${this.videoSlot.id}-video`;
      video.muted = true;
      video.defaultMuted = true;
      const options = { signal: this.controller.signal };
      video.addEventListener('playing', () => {
        if (video !== this.video) return;
        this.videoSlot.classList.add('has-played');
        this.updateControl();
      }, options);
      video.addEventListener('pause', () => {
        if (video === this.video) this.updateControl();
      }, options);
      video.addEventListener('error', () => {
        requestAnimationFrame(() => {
          if (video !== this.video) return;
          if (!video.error && video.networkState !== HTMLMediaElement.NETWORK_NO_SOURCE) return;
          this.videoSlot.classList.remove('has-played');
          this.control.hidden = true;
        });
      }, { ...options, capture: true });
    }

    async play() {
      this.createVideo();
      const video = this.video;
      if (!video) return;
      video.muted = true;
      try {
        await video.play();
      } catch {
        if (video === this.video) this.videoSlot.classList.remove('has-played');
      }
      if (video === this.video) this.updateControl();
    }

    updateControl() {
      const playing = this.video && !this.video.paused;
      this.control.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      this.control.dataset.state = playing ? 'playing' : 'paused';
    }
  }

  customElements.define('vb2-motion-hero', VB2MotionHero);
}

